import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from 'firebase/auth';
import { query, getDocs, collection, where } from 'firebase/firestore';
import { createNewProfile } from './firestore';

import { db, auth } from './firebaseConnection';

const googleProvider = new GoogleAuthProvider();

const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;

    const q = query(collection(db, 'profiles'), where('uid', '==', user.uid));
    const docs = await getDocs(q); // getAll method
    if (docs.docs.length === 0) {
      createNewProfile(user);
    }
  } catch (err: any) {
    console.error(err);
    alert(err.message);
  }
};

// const signInWithFacebook = async () => {
//   try {
//     const res = await signInWithPopup(auth, FacebookAuthProvider);
//     const user = res.user;
//     const q = query(collection(db, 'profiles'), where('uid', '==', user.uid));
//     const docs = await getDocs(q);
//     if (docs.docs.length === 0) {
//       await addDoc(collection(db, 'profiles'), {
//         uid: user.uid,
//         name: user.displayName,
//         authProvider: 'facebook',
//         email: user.email,
//         profilePic: user.photoURL,
//         relaxMethods: [],
//       });
//     }
//   } catch (err) {
//     console.error(err);
//     alert(err.message);
//   }
// };

const logInWithEmailAndPassword = async (email: string, password: string) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (err:any) {
    console.error(err);
    alert(err.message);
  }
};

const registerWithEmailAndPassword = async (profileName: string, email: string, password: string) => {
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;
    await createNewProfile(user, profileName);
  } catch (err:any) {
    console.error(err);
    alert(err.message);
  }
};

const sendPasswordReset = async (email:string) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert('Password reset link sent!');
  } catch (err:any) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  signOut(auth);
};

export {
  auth,
  db,
  signInWithGoogle,
  logInWithEmailAndPassword,
  registerWithEmailAndPassword,
  sendPasswordReset,
  logout,
};
